'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _required = require('@marmalade/validation/lib/required');
var _required2 = _interopRequireDefault(_required);
var _oneByOne = require('@marmalade/validation/lib/one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _atLeast = require('@marmalade/validation/lib/at-least');
var _atLeast2 = _interopRequireDefault(_atLeast);
var _atMost = require('@marmalade/validation/lib/at-most');
var _atMost2 = _interopRequireDefault(_atMost);
var _postcode = require('@marmalade/validation/lib/postcode');
var _postcode2 = _interopRequireDefault(_postcode);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (fdiQuickQuote) {
  return {
    value: fdiQuickQuote ? (0, _oneByOne2.default)((0, _required2.default)('Please specify the value of the car'), (0, _atLeast2.default)(1, 'Please specify the value of the car'), (0, _atMost2.default)(30000, 'Sorry, we can only insure vehicles up to £30,000')) : function () {
      return '';
    },
    postcode: _postcode2.default,
    age: (0, _oneByOne2.default)((0, _required2.default)('Please select your age'), (0, _atLeast2.default)(17, 'You must be at least 17 to take out our provisional driver insurance policy'), (0, _atMost2.default)(34, 'You must be under 35 to take out our provisional driver insurance policy'))
  };
};